import { useState, useEffect } from 'react';
import { AppConfig, configService } from '../services/ConfigService';

export const useConfig = () => {
    const [config, setConfig] = useState<AppConfig | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadConfig = async () => {
            try {
                setLoading(true);
                const appConfig = await configService.getConfig();
                setConfig(appConfig);
                setError(null);
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to load configuration');
            } finally {
                setLoading(false);
            }
        };

        loadConfig();
    }, []);

    return {
        config,
        loading,
        error,
        getExternalApiBaseUrl: () => configService.getExternalApiBaseUrl(),
    };
};
